/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import LetterTemplateTableGrid from './LtTableGrid';
import {
  WindowAddressTableHead,
  letterTemplateTableHead1,
  mergeFieldTemplateHead,
  subMergeFieldTemplateHead,
} from './LtTableHead';
import { getAllSubMergeFieldList } from '../../store/actions';
import RadioGroupComponent from '../../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxWithoutBoxComponent from '../../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import {
  gridType,
  isDynamicDisplayOrderMergeField,
  isPageNumberMergeField,
} from './ConstantData';
import {
  handleQuarterFormate,
  getQtrValWithoutQ,
  checkQuarterValidation,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  CONTRACT_START_QUARTER_FORMAT_ERROR,
  CONTRACT_END_QUARTER_FORMAT_ERROR,
  NO_DRAMS_INVOICE_QUATER,
} from '../../../../../SharedModules/Errors/constantMessageData';

const getSavedDisplayOrder = (item) => {
  if (item?.displayOrder != null && item.displayOrder !== '') {
    return Number(item.displayOrder);
  }
  if (item?.itemOrder != null && item.itemOrder !== '') {
    return Number(item.itemOrder);
  }
  return null;
};

const getCurrentDisplayOrder = (item) => {
  if (item?.displayOrder != null && item.displayOrder !== '') {
    return Number(item.displayOrder);
  }
  return null;
};

const setNodeFieldValue = (cellInfo, node, field, value) => {
  if (cellInfo.columnApi?.getColumn(field)) {
    node.setDataValue(field, value);
  } else if (node?.data) {
    node.data[field] = value;
  }
};

const setNodeDisplayOrder = (cellInfo, node, value) => {
  setNodeFieldValue(cellInfo, node, 'displayOrder', value);
  if (node?.data) {
    node.data.itemOrder = value;
  }
};

export default function LTCommonModal(props) {
  const {
    setLoading,
    pageView,
    onSelectRow,
    selectedMergeField,
    onSelectMergeRow,
    onSelectSubMergeRow,
    onClickAction,
    editBodyMergeField,
    setState,
    mainFilterValue,
    setIsError,
    setIsErrorMsg,
    hidePageNumberMergeField,
  } = props;

  const dispatch = useDispatch();
  const gridRef = React.useRef();
  const selectedDataList1Ref = React.useRef([]);
  const previousTemplateVersion = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.previousTemplateVersion
  );
  const allMergeFieldList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.allMergeFieldList
  );
  const allSubMergeFieldList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.allSubMergeFieldList
  );
  const windowAddrPos = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.windowAddrPos
  );
  const dramsInvStartQtr = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.dramsInvStartQtr
  );

  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [fullScreenSubView, setFullScreenSubView] = React.useState(false);
  const [dataList1, setSetDataList1] = React.useState([]);
  const [selectedDataList1, setSelectedDataList1] = React.useState([]);
  const [totalResultCount1, setTotalResultCount1] = React.useState(0);
  const [selectedSMF, setSelectedSMF] = React.useState([]);
  const [dataList2, setSetDataList2] = React.useState([]);
  const [viewQtrSelect, setViewQtrSelect] = React.useState(false);
  const [viewOrderBy, setViewOrderBy] = React.useState(false);
  const [totalResultCount2, setTotalResultCount2] = React.useState(0);
  const [filterValue, setFilterValue] = React.useState({
    startQtr: 'O',
    startQtrCd: '',
    endQtr: 'O',
    endQtrCd: '',
  });
  const [qtrErr, setQtrErr] = React.useState({
    startQtrCd: false,
    endQtrCd: false,
  });

  const getPreviousTemplateVersion = React.useCallback(() => {
    let prevList = [];
    setSelectedSMF([]);
    if (previousTemplateVersion && !_.isEmpty(previousTemplateVersion)) {
      if (
        previousTemplateVersion.message === 'SUCESS' &&
        previousTemplateVersion.status === '001'
      ) {
        prevList = previousTemplateVersion.letterTemplate.templateHeaderVO;
      }
    }
    setLoading(false);
    setSetDataList1(prevList);
  }, [previousTemplateVersion]);

  const callGetWindowAddrPosList = React.useCallback(() => {
    let prevList = [];
    setSelectedSMF([]);
    if (windowAddrPos && !_.isEmpty(windowAddrPos)) {
      prevList = windowAddrPos;
    }
    setLoading(false);
    setSetDataList1(prevList);
  }, [windowAddrPos]);

  const callGetAllMergeFieldList = React.useCallback(() => {
    let prevList = [];
    setSelectedSMF([]);
    if (allMergeFieldList && !_.isEmpty(allMergeFieldList)) {
      prevList = hidePageNumberMergeField
        ? allMergeFieldList.filter(
            (item) => !isPageNumberMergeField(item?.description)
          )
        : allMergeFieldList;
      setTotalResultCount1(prevList.length);
    }
    setLoading(false);
    setSetDataList1(_.cloneDeep(prevList));
  }, [allMergeFieldList, hidePageNumberMergeField]);

  const cellValueUpdateCustom = React.useCallback((params) => {
    if (params?.api) {
      params.api.refreshCells({
        force: params.data,
      });
    }
  }, []);

  React.useEffect(() => {
    setSetDataList1([]);
    if (pageView === 'previousTemplateVersion') {
      getPreviousTemplateVersion();
    }
    if (pageView === 'allMergeField') {
      callGetAllMergeFieldList();
    }
    if (pageView === 'windowPosition') {
      callGetWindowAddrPosList();
    }
    if (pageView === 'updateMergeField') {
      const list = !_.isEmpty(editBodyMergeField)
        ? _.orderBy(editBodyMergeField, ['templateMetaDataSeqNum'], ['asc'])
        : [];
      setTotalResultCount1(list.length);
      setSetDataList1(list);
    }
  }, [
    pageView,
    previousTemplateVersion,
    windowAddrPos,
    allMergeFieldList,
    editBodyMergeField,
    hidePageNumberMergeField,
  ]);

  React.useEffect(() => {
    if (_.includes(['allMergeField', 'updateMergeField'], pageView)) {
      let prevList = [];
      if (allSubMergeFieldList && !_.isEmpty(allSubMergeFieldList)) {
        prevList = allSubMergeFieldList;
        const currentMergeDescription =
          selectedDataList1Ref.current?.[0]?.description;
        const useDynamicDisplayOrder = isDynamicDisplayOrderMergeField(
          currentMergeDescription
        );
        prevList.forEach((item) => {
          const isSelected = !_.isEmpty(selectedSMF)
            ? _.filter(
                selectedSMF,
                (l) => l.columnHeading === item.columnHeading && l.isSelected
              )
            : [];
          item.isSelected = !_.isEmpty(isSelected);
          if (
            !_.isEmpty(selectedDataList1) &&
            selectedDataList1[0]?.displayTypeCd === gridType &&
            !_.isEmpty(isSelected)
          ) {
            item.orderNum = isSelected[0].orderNum;
            item.isSort = isSelected[0].isSort;
            item.orderType = isSelected[0].orderType;
          } else {
            item.orderNum = null;
            item.isSort = false;
            item.orderType = null;
          }
          if (useDynamicDisplayOrder) {
            if (pageView === 'allMergeField') {
              item.displayOrder = null;
              item.itemOrder = null;
            } else if (!_.isEmpty(isSelected)) {
              const savedOrder = getSavedDisplayOrder(isSelected[0]);
              item.displayOrder = savedOrder;
              item.itemOrder = savedOrder;
            } else {
              item.displayOrder = null;
              item.itemOrder = null;
            }
          }
          return item;
        });
      }
      setLoading(false);
      setTotalResultCount2(!_.isEmpty(prevList) ? prevList.length : 0);
      setSetDataList2(_.cloneDeep(prevList));
    }
  }, [allSubMergeFieldList]);

  const checkSplitTypeQtr = (data) => {
    let val = {
      qType: '',
      qValue: '',
    };
    if (data) {
      let checkType = '';
      if (_.includes(data, 'O')) {
        checkType = 'O';
      }
      if (_.includes(data, 'D')) {
        checkType = 'D';
      }
      if (_.includes(data, 'F')) {
        checkType = 'F';
      }
      const spStQt = _.split(data, checkType);
      val = {
        qType: checkType,
        qValue: checkType === 'O' ? spStQt[1] : handleQuarterFormate(spStQt[1]),
      };
    }
    return val;
  };

  const setOnSelectDataList = (val) => {
    if (val && !_.isEmpty(val)) {
      const selectedRows = val.api.getSelectedRows();
      setSelectedDataList1(selectedRows);
      selectedDataList1Ref.current = selectedRows;
      setViewQtrSelect(false);
      setViewOrderBy(false);
      onSelectMergeRow({
        mergeField: selectedRows,
      });
      if (selectedRows[0]?.description === 'Past Due Invoice Data') {
        setViewQtrSelect(true);
        const qtrVal = {
          startQtr: 'O',
          startQtrCd: '',
          endQtr: 'O',
          endQtrCd: '',
        };
        if (selectedRows[0].startQtrCd) {
          const stQtr = checkSplitTypeQtr(selectedRows[0].startQtrCd);
          qtrVal.startQtr = stQtr.qType;
          qtrVal.startQtrCd = stQtr.qValue;
        }
        if (selectedRows[0].endQtrCd) {
          const stQtr = checkSplitTypeQtr(selectedRows[0].endQtrCd);
          qtrVal.endQtr = stQtr.qType;
          qtrVal.endQtrCd = stQtr.qValue;
        }
        setFilterValue({
          startQtr: qtrVal.startQtr,
          startQtrCd: qtrVal.startQtrCd,
          endQtr: qtrVal.endQtr,
          endQtrCd: qtrVal.endQtrCd,
        });
        if (setState) {
          setState({
            startQtr: qtrVal.startQtr,
            startQtrCd: qtrVal.startQtrCd,
            endQtr: qtrVal.endQtr,
            endQtrCd: qtrVal.endQtrCd,
          });
        }
      }
      if (selectedRows[0]?.displayTypeCd === 'GRID') {
        setViewOrderBy(true);
      }
      if (val.data && !_.isEmpty(val.data) && val.data.templateMetaDataSeqNum) {
        if (val.data.tempDatailItems && !_.isEmpty(val.data.tempDatailItems)) {
          let constselecteMF = _.map(val.data.tempDatailItems, (it) => ({
            ...it,
            isSelected: !it.tempdItemRemoved,
          }));
          if (val.data.orderBy) {
            const orderList = _.split(val.data.orderBy, ', ');
            const cloneConstselecteMF = _.cloneDeep(constselecteMF);

            const orderNameList = _.map(orderList, (item, ind) => {
              const orSpi = _.split(item, ' ');
              const nameId = _.replace(orSpi[0], "'", '');
              const orderId = orSpi[1];
              const reData = {
                nameId: nameId,
                orderNum: ind + 1,
                isSort: true,
                orderType: orderId,
              };
              return reData;
            });
            constselecteMF = _.map(cloneConstselecteMF, (it) => {
              const filterData = _.filter(
                orderNameList,
                (l) => it.columnName === l.nameId
              );
              if (!_.isEmpty(filterData)) {
                it.orderNum = filterData[0]?.orderNum;
                it.isSort = filterData[0]?.isSort;
                it.orderType = filterData[0]?.orderType;
              }
              return it;
            });
          }
          setSelectedSMF(constselecteMF);
        } else {
          setSelectedSMF([]);
        }
        setLoading(true);
        dispatch(
          getAllSubMergeFieldList({
            templateMetaDataSeqNum: val.data.templateMetaDataSeqNum,
          })
        );
      }
    }
  };
  React.useEffect(() => {
    selectedDataList1Ref.current = selectedDataList1;
  }, [selectedDataList1]);

  const applyDynamicDisplayOrder = React.useCallback((cellInfo, isSelected) => {
    const currRow = cellInfo.node?.data;
    if (!currRow) return;

    const previousDisplayOrder = getCurrentDisplayOrder(currRow);

    if (isSelected) {
      let maxOrder = 0;
      cellInfo.api.forEachNode((node) => {
        const it = node.data;
        if (
          it.isSelected &&
          it.templateMetaDataItemSeqNum !== currRow.templateMetaDataItemSeqNum
        ) {
          const order = getCurrentDisplayOrder(it);
          if (order != null && order > maxOrder) {
            maxOrder = order;
          }
        }
      });
      setNodeDisplayOrder(cellInfo, cellInfo.node, maxOrder + 1);
    } else {
      setNodeDisplayOrder(cellInfo, cellInfo.node, null);
      cellInfo.api.forEachNode((node) => {
        const it = node.data;
        if (
          it.templateMetaDataItemSeqNum === currRow.templateMetaDataItemSeqNum
        ) {
          it.displayOrder = null;
          it.itemOrder = null;
        } else {
          const order = getCurrentDisplayOrder(it);
          if (
            previousDisplayOrder != null &&
            order != null &&
            _.gt(order, previousDisplayOrder)
          ) {
            it.displayOrder = order - 1;
            it.itemOrder = order - 1;
          }
        }
        setNodeDisplayOrder(cellInfo, node, it.displayOrder);
      });
    }
  }, []);

  const syncSelectedSubMergeRows = React.useCallback(
    (cellInfo) => {
      const selectedRows = cellInfo.node?.parent?.allLeafChildren;
      const nodeAllData = !_.isEmpty(selectedRows)
        ? _.map(selectedRows, 'data')
        : [];
      const newList = _.filter(nodeAllData, (l) => l.isSelected === true);
      onSelectSubMergeRow({
        selectedRows: newList,
      });
    },
    [onSelectSubMergeRow]
  );

  const selectCheckBox = React.useCallback(
    (cellInfo) => {
      let newList = [];
      if (_.includes(['updateMergeField', 'allMergeField'], pageView)) {
        const selectedRows = cellInfo.node?.parent.allLeafChildren;
        const nodeAllData = _.map(selectedRows, 'data');
        newList = !_.isEmpty(selectedRows)
          ? _.filter(nodeAllData, (l) => l.isSelected === true)
          : [];
        onSelectSubMergeRow({
          selectedRows: newList,
        });
      }

      const currentSelectedMergeField = selectedDataList1Ref.current;

      let isDisabled = false;
      const restrictedDescriptions = [
        'Sender Info',
        'Contact Name',
        'Manufacturer Info',
      ];
      const isRestricted =
        !_.isEmpty(currentSelectedMergeField) &&
        _.includes(
          restrictedDescriptions,
          currentSelectedMergeField[0]?.description
        );
      if (isRestricted) {
        const rowsData = cellInfo.node?.parent.allLeafChildren;
        const nodeAllData = _.map(rowsData, 'data');
        const selectedCheckboxCount = _.filter(
          nodeAllData,
          (l) => l.isSelected === true
        ).length;
        isDisabled =
          selectedCheckboxCount > 0 && !cellInfo.node?.data.isSelected;
      }

      const useDynamicDisplayOrder = isDynamicDisplayOrderMergeField(
        currentSelectedMergeField?.[0]?.description
      );

      return (
        <FormControlLabel
          control={<Checkbox color="primary" />}
          onChange={() => {
            const isSelected = !cellInfo.node?.data.isSelected;
            cellInfo.node.setDataValue(cellInfo.column.colId, isSelected);
            if (!isSelected) {
              if (cellInfo.columnApi.getColumn('isSort')) {
                cellInfo.node.setDataValue('isSort', false);
              } else {
                cellInfo.node.data.isSort = false;
              }

              if (cellInfo.columnApi.getColumn('orderType')) {
                cellInfo.node.setDataValue('orderType', null);
              } else {
                cellInfo.node.data.orderType = null;
              }
              const currRow = cellInfo.node?.data;

              cellInfo.api.forEachNode((node) => {
                const it = node.data;
                if (
                  it.templateMetaDataItemSeqNum ===
                  currRow.templateMetaDataItemSeqNum
                ) {
                  it.orderNum = null;
                }
                if (_.gt(it.orderNum, currRow.orderNum)) {
                  if (it.orderNum < 1) it.orderNum -= 1;
                }
                if (cellInfo.columnApi.getColumn('orderNum')) {
                  node.setDataValue('orderNum', it.orderNum);
                } else {
                  node.data.orderNum = it.orderNum;
                }
              });
            }
            if (useDynamicDisplayOrder) {
              applyDynamicDisplayOrder(cellInfo, isSelected);
              syncSelectedSubMergeRows(cellInfo);
            }
          }}
          disabled={isDisabled}
          checked={cellInfo.node?.data.isSelected}
          data-testid="letter-template-table-grid-checkbox"
          id="exclude-checkbox"
        />
      );
    },
    [
      pageView,
      onSelectSubMergeRow,
      applyDynamicDisplayOrder,
      syncSelectedSubMergeRows,
    ]
  );

  const sortCheckBox = (cellInfo) => {
    const isDisabled = !cellInfo.node?.data.isSelected;
    return (
      <FormControlLabel
        control={<Checkbox color="primary" />}
        onChange={() => {
          if (cellInfo.node?.data.isSelected) {
            const currRow = cellInfo.node?.data;
            const isSort = !currRow.isSort;
            cellInfo.node.setDataValue(cellInfo.column.colId, isSort);
            cellInfo.node.setDataValue('orderType', isSort ? 'ASC' : null);
            const selectedRows = cellInfo.node?.parent.allLeafChildren;
            const nodeAllData = _.map(selectedRows, 'data');
            const getMaxByOrder = _.maxBy(nodeAllData, 'orderNum');
            if (isSort) {
              const nob = !_.isEmpty(getMaxByOrder)
                ? getMaxByOrder.orderNum + 1
                : 1;
              cellInfo.node.setDataValue('orderNum', nob);
            } else {
              cellInfo.api.forEachNode((node) => {
                const it = node.data;
                if (
                  it.templateMetaDataItemSeqNum ===
                  currRow.templateMetaDataItemSeqNum
                ) {
                  it.orderNum = null;
                }
                if (_.gt(it.orderNum, currRow.orderNum)) {
                  it.orderNum -= 1;
                }
                node.setDataValue('orderNum', it.orderNum);
              });
            }
          }
        }}
        disabled={isDisabled}
        checked={cellInfo.node?.data.isSort}
        data-testid="letter-template-table-grid-checkbox"
        id="exclude-checkbox"
      />
    );
  };

  const orderTypeSelectBox = (cellInfo) => {
    const isDisabled = !cellInfo.node?.data.isSort;
    return (
      <SelectBoxWithoutBoxComponent
        data-testid="contact-type-input"
        required={false}
        disabled={isDisabled}
        select
        selectedOne={false}
        optionList={[
          { id: 'ASC', name: 'Ascending' },
          { id: 'DESC', name: 'Descending' },
        ]}
        className="frr-order-type-select"
        defaultValue={cellInfo.node?.data.orderType}
        filterAction={(e) => {
          if (cellInfo.node?.data.isSort && cellInfo.node?.data.isSelected) {
            cellInfo.node.setDataValue(cellInfo.column.colId, e);
          }
        }}
      />
    );
  };

  const pastDueInvoiceRadio = React.useMemo(() => {
    return [
      { value: 'O', name: 'Prior to Selected Qtr' },
      { value: 'D', name: 'DRAMS Invoice Start Qtr' },
      { value: 'F', name: 'Fixed Qtr' },
    ];
  }, []);

  const PrioeSelectedQtrDropdown = React.useMemo(() => {
    const qtrRange = _.times(11, (i) => ({ id: i, name: i }));
    return qtrRange;
  }, []);

  const changeQtrValue = (flType, val) => {
    let value = null;
    if (flType === 'O') {
      value = `O${val}`;
    } else {
      const newVal = val ? getQtrValWithoutQ(val) : null;
      value = newVal ? flType + newVal : null;
    }
    return value;
  };

  const setQtrValInMergeField = (row) => {
    const newData = !_.isEmpty(selectedMergeField)
      ? _.cloneDeep(selectedMergeField)
      : _.cloneDeep(selectedDataList1);
    newData.forEach((item) => {
      item.startQtrCd = row.startQtrCd;
      item.endQtrCd = row.endQtrCd;
      return item;
    });
    setSelectedDataList1(newData);
    onSelectMergeRow({
      mergeField: newData,
    });
  };

  const qtrChangeAction = (flType, value) => {
    const data = _.cloneDeep(filterValue);
    data[flType] = value;
    const data1 = _.cloneDeep(data);
    data1[flType] = value;
    const crtData = selectedDataList1[0];
    data1.startQtrCd = flType === 'startQtr' ? null : crtData.startQtrCd;
    data1.endQtrCd = flType === 'endQtr' ? null : crtData.endQtrCd;
    data.startQtrCd = flType === 'startQtr' ? null : data.startQtrCd;
    data.endQtrCd = flType === 'endQtr' ? null : data.endQtrCd;
    if (flType === 'startQtr' && value === 'D') {
      data1.startQtrCd = changeQtrValue(value, dramsInvStartQtr);
      data1.endQtrCd = crtData.endQtrCd;
    }
    if (flType === 'endQtr' && value === 'D') {
      data1.endQtrCd = changeQtrValue(value, dramsInvStartQtr);
      data1.startQtrCd = crtData.startQtrCd;
    }
    if (data.startQtr === 'O' && flType === 'startQtrCd') {
      const hasStartQtrCd =
        data.startQtrCd !== null &&
        data.startQtrCd !== undefined &&
        data.startQtrCd !== '';
      data1.startQtrCd = hasStartQtrCd
        ? changeQtrValue(data.startQtr, data.startQtrCd)
        : null;
      data1.endQtrCd = crtData.endQtrCd;
    }
    if (data.endQtr === 'O' && flType === 'endQtrCd') {
      const hasEndQtrCd =
        data.endQtrCd !== null &&
        data.endQtrCd !== undefined &&
        data.endQtrCd !== '';
      data1.endQtrCd = hasEndQtrCd
        ? changeQtrValue(data.endQtr, data.endQtrCd)
        : null;
      data1.startQtrCd = crtData.startQtrCd;
    }
    setQtrValInMergeField({
      startQtrCd: data1.startQtrCd,
      endQtrCd: data1.endQtrCd,
    });
    const hasValue =
      data1[flType] !== null &&
      data1[flType] !== undefined &&
      data1[flType] !== '';
    data[flType] = hasValue ? value : null;
    setFilterValue(data);
    const rErr = flType === 'startQtr' ? 'startQtrCd' : 'endQtrCd';
    setQtrErr({
      ...qtrErr,
      [rErr]: false,
    });
  };

  const onBlurAction = (flType, value) => {
    const data1 = { ...filterValue };
    const data = _.cloneDeep(data1);
    data[flType] = value;
    const newQtrErr = qtrErr;

    const crtData = selectedDataList1[0];

    const validateStartQtr = data.startQtrCd
      ? checkQuarterValidation(data.startQtrCd)
      : true;
    const validateEndQtr = data.endQtrCd
      ? checkQuarterValidation(data.endQtrCd)
      : true;

    if (data.startQtr === 'F' && flType === 'startQtrCd') {
      data.startQtrCd = validateStartQtr
        ? changeQtrValue(data.startQtr, data.startQtrCd)
        : null;
      data.endQtrCd = crtData.endQtrCd;
      newQtrErr.startQtrCd = !data.startQtrCd;
    }
    if (data.endQtr === 'F' && flType === 'endQtrCd') {
      data.endQtrCd = validateEndQtr
        ? changeQtrValue(data.endQtr, data.endQtrCd)
        : null;
      data.startQtrCd = crtData.startQtrCd;
      newQtrErr.endQtrCd = !data.endQtrCd;
    }
    setQtrValInMergeField({
      startQtrCd: data.startQtrCd,
      endQtrCd: data.endQtrCd,
    });
    data1[flType] = data[flType] ? value : null;
    setFilterValue(data1);
    setQtrErr(newQtrErr);
  };

  const seubMergeFieldTableHed = React.useMemo(() => {
    const columnList = viewOrderBy
      ? subMergeFieldTemplateHead
      : _.filter(
          subMergeFieldTemplateHead,
          (l) => !_.includes(['orderNum', 'isSort', 'orderType'], l.field)
        );
    return columnList;
  }, [subMergeFieldTemplateHead, viewOrderBy]);

  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setFullScreenSubView(false);
  };

  const changeFullScreenSubView = () => {
    setFullScreenSubView(!fullScreenSubView);
    setFullScreenView(false);
  };

  return (
    <div
      className="lt-common-modal common-popup"
      data-testid="letter-template-common-component"
    >
      {!fullScreenSubView && (
        <div className="letter-template-popup">
          <LetterTemplateTableGrid
            data-testid="letter-template-common-table1"
            gridRef={gridRef}
            cellHead={
              pageView === 'windowPosition'
                ? WindowAddressTableHead
                : pageView === 'previousTemplateVersion'
                ? letterTemplateTableHead1
                : mergeFieldTemplateHead
            }
            dataList={dataList1 || []}
            gridHeight={
              fullScreenView
                ? '70vh'
                : _.includes(
                    ['previousTemplateVersion', 'windowPosition'],
                    pageView
                  )
                ? 352
                : 300
            }
            fileName={
              pageView === 'windowPosition'
                ? 'Window Address Position'
                : pageView === 'previousTemplateVersion'
                ? 'Previous Template Version'
                : 'Letter Template Merge Fields'
            }
            fullScreenViewTable={
              pageView === 'windowPosition'
                ? 'Window Address Position'
                : pageView === 'previousTemplateVersion'
                ? 'Previous Template Version'
                : 'Letter Template Merge Fields'
            }
            setFullScreenView={changeFullScreenView}
            fullScreenView={fullScreenView}
            fullScreenIcon
            filterIcon
            tableHeader
            actionIcon
            setTotalResultCount={setTotalResultCount1}
            childPopup
            onSelect={(e) =>
              _.includes(
                ['previousTemplateVersion', 'windowPosition'],
                pageView
              )
                ? onSelectRow(e.data)
                : setOnSelectDataList(e)
            }
            cellClickedListener={(e) =>
              pageView === 'previousTemplateVersion'
                ? onClickAction('Update', e.data)
                : null
            }
            onCellKeyDown={(e) => {
              if (e.event.key === 'Enter') {
                if (
                  _.includes(
                    ['previousTemplateVersion', 'windowPosition'],
                    pageView
                  )
                ) {
                  onSelectRow(e.data);
                  if (pageView === 'previousTemplateVersion') {
                    onClickAction('Update', e.data);
                  }
                } else {
                  setOnSelectDataList(e);
                }
              }
            }}
          />
          {/* <p className="total-results" tabIndex="0">
            Total Results:
            <b>{totalResultCount1}</b>
          </p> */}
        </div>
      )}

      {dataList2 && !_.isEmpty(dataList2) && !fullScreenView && (
        <div className="frr-sub-merge-field-table">
          <LetterTemplateTableGrid
            data-testid="letter-template-common-table2"
            gridRef={gridRef}
            cellHead={seubMergeFieldTableHed}
            dataList={dataList2 || []}
            gridHeight={fullScreenSubView ? '70vh' : 200}
            fileName="Letter Template Sub-Merge Fields"
            fullScreenViewTable="Letter Template Sub-Merge Fields"
            setFullScreenView={changeFullScreenSubView}
            fullScreenView={fullScreenSubView}
            fullScreenIcon
            filterIcon
            tableHeader
            actionIcon
            rowSelection="single"
            childPopup
            rowMultiSelectWithClick={false}
            setTotalResultCount={setTotalResultCount2}
            onCellValueChanged={(e) => cellValueUpdateCustom(e)}
            onSelect={(e) => onSelectSubMergeRow({ selectedRows: [e.data] })}
            onCellKeyDown={(e) => {
              if (e.event.key === 'Enter') {
                const isSelected = !e.node?.data.isSelected;
                e.node.setDataValue('isSelected', isSelected);
                if (
                  isDynamicDisplayOrderMergeField(
                    selectedDataList1Ref.current?.[0]?.description
                  )
                ) {
                  applyDynamicDisplayOrder(e, isSelected);
                  syncSelectedSubMergeRows(e);
                } else {
                  onSelectSubMergeRow({ selectedRows: [e.data] });
                }
              }
            }}
            ExtraFrameworkComponents={{
              selectCheckBox: selectCheckBox,
              sortCheckBox: sortCheckBox,
              orderTypeSelectBox: orderTypeSelectBox,
            }}
          />
          {/* <p className="total-results" tabIndex="0">
            Total Results:
            <b>{totalResultCount2}</b>
          </p> */}
        </div>
      )}

      {viewQtrSelect && !fullScreenView && !fullScreenSubView && (
        <div className="p-3">
          <div className="row">
            <div className="col-6">
              <div className="mui-custom-form no-margin custom-check">
                <fieldset
                  data-testid="radio-box-component"
                  className="custom-fieldset"
                >
                  <legend className="same-font-family">Start Quarter:</legend>
                  <RadioGroupComponent
                    data-testid="start-quarter-redio-btn"
                    id="start-quarter-radio-btn2"
                    labelName="Start Quarter"
                    required={false}
                    optionList={pastDueInvoiceRadio}
                    defaultValue={filterValue?.startQtr}
                    filterAction={(e) => {
                      if (e === 'D') {
                        if (dramsInvStartQtr) {
                          qtrChangeAction('startQtr', e);
                        } else {
                          setIsError(true);
                          setIsErrorMsg(
                            NO_DRAMS_INVOICE_QUATER(
                              mainFilterValue?.rebateProgramCd
                            )
                          );
                        }
                      } else {
                        qtrChangeAction('startQtr', e);
                      }
                    }}
                    className="log-batch-filter-radio"
                    viewBorder={false}
                    viewTitle={false}
                  />
                  {filterValue?.startQtr !== 'D' && (
                    <SelectBoxWithoutBoxComponent
                      data-testid="start-quarter-input"
                      labelName="Start Quarter"
                      disabled={false}
                      inputProps={{ maxlength: 50 }}
                      select={filterValue?.startQtr === 'O'}
                      selectedOne={false}
                      optionList={PrioeSelectedQtrDropdown || []}
                      defaultValue={filterValue.startQtrCd}
                      filterAction={(e) => qtrChangeAction('startQtrCd', e)}
                      onBlurAction={(e) => {
                        if (filterValue?.startQtr !== 'O') {
                          onBlurAction('startQtrCd', e);
                        }
                      }}
                      isError={
                        qtrErr.startQtrCd
                          ? CONTRACT_START_QUARTER_FORMAT_ERROR
                          : false
                      }
                    />
                  )}
                </fieldset>
              </div>
            </div>
            <div className="col-6">
              <div className="mui-custom-form no-margin custom-check">
                <fieldset
                  data-testid="radio-box-component"
                  className="custom-fieldset"
                >
                  <legend className="same-font-family">End Quarter:</legend>
                  <RadioGroupComponent
                    data-testid="end-quarter-redio-btn"
                    id="end-quarter-radio-btn1"
                    labelName="End Quarter"
                    required={false}
                    optionList={pastDueInvoiceRadio}
                    defaultValue={filterValue?.endQtr}
                    filterAction={(e) => {
                      if (e === 'D') {
                        if (dramsInvStartQtr) {
                          qtrChangeAction('endQtr', e);
                        } else {
                          setIsError(true);
                          setIsErrorMsg(
                            NO_DRAMS_INVOICE_QUATER(
                              mainFilterValue?.rebateProgramCd
                            )
                          );
                        }
                      } else {
                        qtrChangeAction('endQtr', e);
                      }
                    }}
                    className="log-batch-filter-radio"
                    viewBorder={false}
                    viewTitle={false}
                  />
                  {filterValue?.endQtr !== 'D' && (
                    <SelectBoxWithoutBoxComponent
                      data-testid="end-quarter-input"
                      labelName="End Quarter"
                      disabled={false}
                      inputProps={{ maxlength: 50 }}
                      select={filterValue?.endQtr === 'O'}
                      selectedOne={false}
                      optionList={PrioeSelectedQtrDropdown || []}
                      defaultValue={filterValue.endQtrCd}
                      filterAction={(e) => qtrChangeAction('endQtrCd', e)}
                      onBlurAction={(e) => {
                        if (filterValue?.endQtr !== 'O') {
                          onBlurAction('endQtrCd', e);
                        }
                      }}
                      isError={
                        qtrErr.endQtrCd
                          ? CONTRACT_END_QUARTER_FORMAT_ERROR
                          : false
                      }
                    />
                  )}
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
